import { accessNested } from 'utils/utils';

// slimmed down version of
// https://github.com/manuelstofer/json-pointer/blob/master/index.js

export function encode(str) {
	return str.replaceAll('~', '~0').replaceAll('/', '~1');
}
export function decode(str) {
	return str.replaceAll('~1', '/').replaceAll('~0', '~');
}

export function parse(path) {
	if (Array.isArray(path)) return path;
	if (!path || typeof path !== 'string') return [];
	if (path.at(0) !== '/') throw new Error(`Invalid JSON pointer ${path}`);
	return path.slice(1).split('/').map(decode);
}
export function compile(pathArray) {
	if (typeof pathArray === 'string') return pathArray;
	if (!Array.isArray(pathArray) || !pathArray?.length) return '';
	return '/' + pathArray.map(encode).join('/');
}

// concats 2 paths - keep the format of the first argument
export function concat(base, ...parts) {
	if (Array.isArray(base)) {
		return base.concat(parts.map(parse));
	}
	return compile(base) + parts.map(compile).join('');
}

export function has(obj, pointer) {
	pointer = parse(pointer);
	let current = obj;
	return pointer.every(key => (current = current[key]));
}

export function get(obj, pointer) {
	pointer = parse(pointer);
	return accessNested(obj, pointer);
}

export function set(obj, pointer, value) {
	pointer = parse(pointer);
	if (!pointer.length) throw new Error('Cannot set the root object');
	const last = pointer.pop();

	const parent = get(obj, pointer);
	if (!parent) throw new Error(`${compile(pointer)} does not exist in object`);

	if (typeof parent.set === 'function') {
		// freezerJS object
		parent.set(last, value);
	} else {
		// Regular object
		parent[last] = value;
	}
	return obj;
}

export function setDeep(obj, pointer, value) {
	pointer = parse(pointer);
	if (!pointer.length) throw new Error('Cannot set the root object');
	const last = pointer.pop();

	let current = obj;
	for (const key of pointer) {
		if (!current[key] || typeof current[key] !== 'object') {
			// Should we try to be smart and use an array if the next key is a number?
			if (typeof current.set === 'function') {
				current = current.set(key, {});
			} else {
				current[key] = {};
			}
		}
		current = current[key];
	}

	if (typeof current.set === 'function') {
		// freezerJS object
		current.set(last, value);
	} else {
		// Regular object
		current[last] = value;
	}
	return obj;
}

export function removeDeep(obj, pointer) {
	pointer = parse(pointer);
	if (!pointer.length) throw new Error('Cannot remove the root object');
	const last = pointer.pop();

	let current = obj;
	for (const key of pointer) {
		if (!current[key] || typeof current[key] !== 'object') {
			return;
		}
		current = current[key];
	}

	if (typeof current.remove === 'function') {
		// freezerJS object
		current.remove(last);
	} else {
		// Regular object
		delete current[last];
	}
}